// @ts-nocheck
/*
 * SAGA NAME CONVENTION: camelCase
 * <NOUN><VERB>
 * RequestStart
*/

import _ from "lodash";
import React, { Component, PureComponent, Fragment, useState, useEffect } from "react";


import { css } from "@emotion/react";
import { put, call, take, select, all, delay, fork, takeLatest, throttle, takeEvery, spawn } from "redux-saga/effects";
import ms from "ms";
import FullStory from "services/Fullstory";
import {
  getApiCommonTime,
  getApiCommunicationSmsSmsIdMarkasread,
  postApiCustomerAffilateClick,
  postApiCustomerAttachAffilates,
  postApiMembershipChangePassword,
  postApiMembershipToken
} from "@src/api-new/generated-api";
import type { MemberDetailsStateType } from "@src/api-new/generated-api.schemas";
import type { ApiError } from "@src/services/ApiClient";

import { Success, Info, Danger, Warning, Progress, Clear } from "kit/alert";
import Storage from "core/Storage";
import QueryString from "core/QueryString";
import { AuthGet } from "core/Auth";
import { replaceRouteParams } from "kit/helpers";
import DateService from "core/DateService";

import { replace } from "../../utils/navigation";
import HEADERS from "../../constants/HEADERS";
import CUSTOMER_STATUSES from "../../constants/CUSTOMER_STATUSES";
import LOAN_STATUSES from "../../constants/LOAN_STATUSES";
import getClientUniqueId from "../../helpers/getClientUniqueId";
import checkIfAddressEmpty from "../../helpers/checkIfAddressEmpty";
import STORAGE from "../../constants/STORAGE";
import normalizeCustomerDto from "../../helpers/normalizeCustomerDto";
import ROUTES_BASED_ON_CUSTOMER_STATUS from "../../constants/ROUTES_BASED_ON_CUSTOMER_STATUS";
import PAYMENT_TYPES from "../../constants/PAYMENT_TYPES";

import { clearLoanFlowParams } from "../LoanFlow/LoanFlow.saga";
import routesObject from "../../routesObject";
import { appActions } from "../App/App.slice";
import { showConfirmDialogAndWaitForAction } from "../Confirm/Confirm.saga";
import { getQueryParameters, getRoute, handleUserLogin } from "../App/App.saga";


export function* getCustomerPayloadWithToken(tokenParam: string): MemberDetailsStateType {
  try {
    const token = _.defaultTo(tokenParam, AuthGet().token);
    const { data } = yield call(postApiMembershipToken, {
      token
    });
    if (data) {
      return {
        memberDetails: normalizeCustomerDto(data),
        token
      };
    }
    return {};
  }
  catch (err) {
    ErrorLoggerService("APP", "Shared.saga", err);
    return undefined;
  }
}

export function* checkCampaignParameters() {
  try {
    const queryParams = yield call(getQueryParameters);
    const anyParameterExists = _(queryParams)
      .pick([
        "utm_campaign",
        "uid",
        "mykredit_ref",
        "campaignid"
      ])
      .values()
      .some();
    if (!anyParameterExists) return;
    const campaignParams = {
      uri: window.location.href,
      params: queryParams,
      createdAt: DateService.lib().tz()
        .format("YYYY-MM-DDTHH:mm:ss.SSS")
    };

    const uniqueClientId = yield call(getClientUniqueId);
    yield fork(postApiCustomerAffilateClick, {
      uniqueClientId,
      history: [
        {
          "occuredAt": _.get(campaignParams, "createdAt"),
          "fullUri": _.get(campaignParams, "uri")
        }
      ],
      affiliateClickSessionId: Storage.Session.get(STORAGE.affiliateSessionId)
    });

    Storage.Session.set(STORAGE.campaignParams, campaignParams);
    Storage.Session.set(STORAGE.campaignInfo, {
      campaignCode: Array.isArray(queryParams.utm_campaign) ? queryParams.utm_campaign?.[0] : queryParams.utm_campaign,
      smsPoolId: queryParams.smsPoolId,
      emailPoolId: queryParams.emailPoolId
    });

  }
  catch (err) {
    ErrorLoggerService("error", "Shared.saga", err); // eslint-disable-line dot-notation
  }
}


export function* sendCampaignParamsForConversionIfExists(occuredAt) {
  const campaignPayload = Storage.Session.get(STORAGE.campaignParams);
  const hasValidCampaign = _.some([
    _.get(campaignPayload, "params.utm_campaign"),
    _.get(campaignPayload, "params.mykredit_ref")
  ]);
  if (hasValidCampaign) {
    const uniqueClientId = yield call(getClientUniqueId);
    yield call(postApiCustomerAttachAffilates, {
      uniqueClientId,
      history: [
        {
          "occuredAt": occuredAt || _.get(campaignPayload, "createdAt"),
          "fullUri": _.get(campaignPayload, "uri")
        }
      ]
    });
    Storage.Session.remove(STORAGE.campaignParams);
  }
}

function* handleLocationChange() {
  window.scrollTo({ top: 0 });
  const isMobileMenuVisible = yield select(state =>
    state.app.isMobileMenuVisible
  );
  if (isMobileMenuVisible) {
    yield put(appActions.toggleMobileMenuVisibility(false));
  }
  yield call(closeActiveModals);
}

function* closeActiveModals() {
  const activeModals = yield select((state) => state.app.modalState);
  const activeModalsKeys = Object.keys(activeModals);
  yield all(
    activeModalsKeys.map((modal) => put(appActions.toggleModalState(modal, false)))
  );
}

function* checkSmsCampaignForReadStatus() {
  try {
    const queryParams = yield call(getQueryParameters);
    if (!queryParams.smsPoolId) return;
    yield call(getApiCommunicationSmsSmsIdMarkasread, queryParams.smsPoolId, {
      ignoreLogs: true
    });
  }
  catch (err) {
    ErrorLoggerService("error", "Shared.saga", err);
  }
}

export function* getCurrentDateTime() {
  try {
    const { data } = yield call(getApiCommonTime);
    if (data) {
      return data;
    }
    return new Date();
  }
  catch (err) {
    window["console"]["log"]("error", "LoanRequest.saga", err); // eslint-disable-line dot-notation
    return new Date();
  }
}

export function checkIfRecaptchaV2Required({ data, errors }: { data?: any, errors?: ApiError[] }) {
  if (data?.v2Required && !!data?.v2PublicKey) {
    return data.v2PublicKey;
  }
  if (errors) {
    const recaptchaV2RequiredError = errors?.find(err => {
      return (err?.code?.value === "CaptchaV2Required" || err?.code?.name === "CaptchaV2Required") && !!err.message;
    });
    return recaptchaV2RequiredError?.message;
  }
  return;
}


export default function* main() {
  yield all([
    takeEvery(appActions.routeExit, handleLocationChange),
    fork(checkSmsCampaignForReadStatus)
  ]);
}
